import type { TOC } from '@ember/component/template-only';
import { PrismIcon, PrismMetricBlock } from '@mylighthouse/prism-ember';
import { and } from 'ember-truth-helpers';
import GeneralPercentageChangeValue from 'lumen/components/general/percentage-change-value';
import type { Occupancy, PredictedOccupancy } from 'lumen/models';

interface HotelPricingAssistantTooltipOtbMetricBlockSignature {
  Args: {
    isCurrentOrFutureDay: boolean;
    label: string;
    occupancyChange: number | undefined | null;
    occupancyData: Occupancy | PredictedOccupancy | undefined;
    showOccupancyChange: boolean;
  };
}

const HotelPricingAssistantTooltipOtbMetricBlock = <template>
  <PrismMetricBlock>
    <:value>
      <div class="flex items-center gap-50">
        <p>{{@occupancyData.formattedOccupancyPercentage}}</p>
        {{#if @showOccupancyChange}}
          <GeneralPercentageChangeValue @changeValue={{@occupancyChange}} />
        {{/if}}
      </div>
    </:value>
    <:label>
      <div class="flex items-center gap-100">
        {{@label}}
        {{#if (and @isCurrentOrFutureDay @occupancyData.isOtbOutOfSync)}}
          <PrismIcon @name="sync-disabled" @size="extra-small" />
        {{/if}}
      </div>
    </:label>
  </PrismMetricBlock>
</template> satisfies TOC<HotelPricingAssistantTooltipOtbMetricBlockSignature>;

export default HotelPricingAssistantTooltipOtbMetricBlock;
